"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemberType_1 = require("./MemberType");
var AccountType_1 = require("./AccountType");
var ContributionTable = (function () {
    function ContributionTable() {
        this._rates = [];
    }
    ContributionTable.prototype.addRate = function (accumulationContributionRate, contributionRate, memberType) {
        this._rates[this.key(contributionRate, memberType)] = accumulationContributionRate;
    };
    ContributionTable.prototype.rate = function (contributionRate, thisAccountType, thisMemberType) {
        if (thisAccountType === AccountType_1.AccountType.ACCUMULATION && thisMemberType === MemberType_1.MemberType.QSUPER_POLICE) {
            return this._rates[(this.key(contributionRate, "qpolice"))];
        }
        else if (thisAccountType === AccountType_1.AccountType.ACCUMULATION && thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT) {
            return this._rates[(this.key(contributionRate, "qsuper"))];
        }
        else if (thisAccountType === AccountType_1.AccountType.ACCUMULATION) {
            return 0.09;
        }
        else {
            return 0;
        }
    };
    ContributionTable.prototype.key = function (contributionRate, memberType) {
        return (Math.floor((100 * contributionRate))) + "" + memberType;
    };
    return ContributionTable;
}());
exports.ContributionTable = ContributionTable;
//# sourceMappingURL=ContributionTable.js.map